export default function createLoggerProxy<T extends object>(obj: T, createProxy = true): T {
	const moduleColor = getColor(obj.constructor.name);
	console.log(
		'%c[Engine]' + `%c→ Instantiated ${obj.constructor.name}`,
		`font-weight: 800; font-size: 1.3em; color: ${moduleColor};`,
		`font-weight: 800; color: ${moduleColor}; font-size: 1.1em`
	);

	// logger passthrough
	if (!createProxy) {
		return obj;
	}

	const handler = {
		get(target, propKey, receiver) {
			const targetValue = Reflect.get(target, propKey, receiver);
			if (typeof targetValue === 'function') {
				return function(...args) {
					console.log(
						`%c[Engine:: ${target.constructor.name}] →` + `%c ${propKey}`,
						`font-weight: 800; color: ${moduleColor}; font-size: 1.2em`,
						`font-weight: 700; color: ${moduleColor}; font-size: 1.1em`,
						args
					);

					// @ts-ignore
					return targetValue.apply(this, args);
				};
			} else {
				return targetValue;
			}
		}
	};
	return new Proxy<T>(obj, handler);
}

function getColor(stringInput: string) {
	let stringUniqueHash = [...stringInput].reduce((acc, char) => {
		return char.charCodeAt(0) + ((acc << 5) - acc);
	}, 0);
	return `hsl(${stringUniqueHash % 360}, 95%, 35%)`;
}
